module.exports = __webpack_public_path__ + "static/henryheadshot-5917c1ac92236e4664cc9c2b071f734e.jpg";